import { apiClient } from './api'
import { resolveEventId } from './eventService'

export interface Avatar {
  photoUrl?: string | null
  avatarKind?: string | null // photo/preset/initials
  avatarPreset?: string | null
  avatarColor?: string | null
  initials?: string | null
}
export interface MyProfile extends Avatar {
  optIn: boolean
  headline?: string | null
  bio?: string | null
  linkedinUrl?: string | null
  websiteUrl?: string | null
  showEmail: boolean
}
export interface DirectoryEntry extends Avatar {
  attendeeId: string
  fullName?: string | null
  company?: string | null
  track?: string | null
  headline?: string | null
  bio?: string | null
  linkedinUrl?: string | null
  websiteUrl?: string | null
  email?: string | null
  connection?: { status: string; direction: string; connectionId: string } | null
}
export interface ConnectionRow {
  id: string
  status: string
  direction: string
  message?: string | null
  attendeeId: string
  fullName?: string | null
  company?: string | null
}
export interface MeetingRow {
  id: string
  title?: string | null
  location?: string | null
  startsAt: string
  endsAt: string
  status: string
  role: string
  withAttendeeId: string
  withName?: string | null
}

async function eid() {
  return resolveEventId()
}

export const networkingService = {
  getProfile: async (): Promise<MyProfile> =>
    apiClient.get<MyProfile>(`/events/${await eid()}/networking/me`).then((r) => r.data),
  updateProfile: async (patch: Partial<MyProfile>): Promise<MyProfile> =>
    apiClient.put<MyProfile>(`/events/${await eid()}/networking/me`, patch).then((r) => r.data),
  directory: async (): Promise<DirectoryEntry[]> =>
    apiClient.get<DirectoryEntry[]>(`/events/${await eid()}/networking/directory`).then((r) => r.data),
  connections: async (): Promise<ConnectionRow[]> =>
    apiClient.get<ConnectionRow[]>(`/events/${await eid()}/networking/connections`).then((r) => r.data),
  requestConnection: async (toAttendeeId: string, message?: string) =>
    apiClient
      .post(`/events/${await eid()}/networking/connections`, { toAttendeeId, message })
      .then((r) => r.data),
  respondConnection: async (id: string, accept: boolean) =>
    apiClient
      .post(`/events/${await eid()}/networking/connections/${id}/respond`, { accept })
      .then((r) => r.data),
  meetings: async (): Promise<MeetingRow[]> =>
    apiClient.get<MeetingRow[]>(`/events/${await eid()}/meetings`).then((r) => r.data),
  checkMeeting: async (attendeeId: string, startsAt: string, endsAt: string) =>
    apiClient
      .post<{ ok: boolean; conflicts: string[] }>(`/events/${await eid()}/meetings/check`, {
        attendeeId,
        startsAt,
        endsAt,
      })
      .then((r) => r.data),
  proposeMeeting: async (payload: {
    attendeeId: string
    startsAt: string
    endsAt: string
    title?: string
    location?: string
  }) => apiClient.post(`/events/${await eid()}/meetings`, payload).then((r) => r.data),
  respondMeeting: async (id: string, accept: boolean) =>
    apiClient.post(`/events/${await eid()}/meetings/${id}/respond`, { accept }).then((r) => r.data),
  cancelMeeting: async (id: string) =>
    apiClient.post(`/events/${await eid()}/meetings/${id}/cancel`).then((r) => r.data),
}
